import { render, staticRenderFns } from "./LessonsList.vue?vue&type=template&id=1f2d013e&scoped=true&"
import script from "./LessonsList.vue?vue&type=script&lang=js&"
export * from "./LessonsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2d013e",
  null
  
)

export default component.exports